var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGooglePlay = function SvgGooglePlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_1_1",
    "data-name": "Componente 1 \\u2013 1",
    width: 19.803,
    height: 22.008,
    viewBox: "0 0 19.803 22.008",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7074",
    "data-name": "Caminho 7074",
    d: "M420.313,306.752l-4.009-2.314-3.3,3.187,3.013,2.913,4.293-2.478a.756.756,0,0,0,0-1.309",
    transform: "translate(-400.888 -296.544)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7075",
    "data-name": "Caminho 7075",
    d: "M164.251,130.939l-4.412-2.547-9.668-4.955,10.92,10.556Z",
    transform: "translate(-149.516 -123.437)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7076",
    "data-name": "Caminho 7076",
    d: "M153.85,399.966l9.525-5.247,4.111-2.373-2.876-2.781Z",
    transform: "translate(-153.034 -377.958)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7077",
    "data-name": "Caminho 7077",
    d: "M135.152,133.23l-.01,21.319,11.032-10.665Z",
    transform: "translate(-135.141 -132.803)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google_play.3b2d7629.svg";
export { ForwardRef as ReactComponent };